import React, { useEffect, useState } from "react";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import MuiAccordion from "@material-ui/core/Accordion";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import MaximizeIcon from "@material-ui/icons/Maximize";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";

const useStylesSearch = makeStyles((theme) => ({
    root: {
        padding: "10px",
        display: "flex",
        alignItems: "center",
        background: "#FAFAFA",
        height: "2rem",
        margin: "0px 15px 20px 15px",
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        borderRadius: "2px",
        fontSize: "12px"
    },
    iconButton: {
        padding: 10,
    },
}));

const useStyles = makeStyles(() => ({
    root: {
        height: "100vh",
        backgroundColor: "white",
        border: "1px solid #BCBBBB",
        width: "100%",
    },
    heading: {
        fontSize: "12px",
        fontWeight: "bold",
        color: "#8C90A2"
    },
    headingActive: {
        fontSize: "12px",
        fontWeight: "bold",
        color: "#fff",
    },
}));
const Accordion = withStyles({
    root: {
        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        minHeight: "0 !important",
        height: "20px",
        "&$expanded": {
            minHeight: 56,
        },
    },
    content: {
        flexDirection: "column",
        "&$expanded": {
            margin: "12px 0",
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);

const LowCodeActivities = (props) => {
    const { t } = useTranslation();
    const [changeIcon, setChangeIcon] = useState(false);
    const [expandedMain, setExpandedMain] = useState(false);
    const classesSearch = useStylesSearch();
    const classes = useStyles();


    useEffect(() => {
        if (expandedMain) {
            setChangeIcon(true);
            setExpandedMain(true);
            props.setExpandedMain(false);
            props.setChangeIcon(false);
        }
    }, [expandedMain, props]);

    useEffect(() => {
        if (props.expandedMain) {
            setExpandedMain(false);
            setChangeIcon(false);
            props.setExpandedMain(true);
        }
    }, [props]);

    const handleChange = () => {
        setChangeIcon(!changeIcon);
        setExpandedMain(!expandedMain);
    }

    return (
        <div>
            <Accordion id="accordion-panel" expanded={expandedMain}>
                <AccordionSummary
                    onClick={() => handleChange()}
                    expandIcon={
                        changeIcon ? (
                            <MaximizeIcon style={{ marginBottom: "-1rem", color: "#fff", height: "20px" }} />
                        ) : (
                            <AddIcon />
                        )
                    }
                    aria-controls="panel1a-content"
                    style={{ margin: "0px 15px 5px 15px", borderRadius: "2px", height: "35px", backgroundColor: changeIcon ? "#46474E" : "#fff" }}
                >
                    <Typography className={changeIcon ? classes.headingActive : classes.heading}>{t('CONTENT.AUTOMS-LIST.LOW-CODE-ACTIVITIES')}</Typography>
                </AccordionSummary>

                <AccordionDetails id="accordion-panel-alt">
                    <Accordion id="accordion-panel">
                        <div className={classesSearch.root}>
                            <IconButton
                                type="submit"
                                className={classesSearch.iconButton}
                                aria-label="search"
                                id="search-icon"
                            >
                                <SearchIcon />
                            </IconButton>
                            <InputBase
                                className={classesSearch.input}
                                placeholder={t("CONTENT.FLOW.SEARCH")}
                                inputProps={{ "aria-label": "" }}
                            />
                        </div>
                    </Accordion>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default LowCodeActivities;
